/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { Tab } from '@headlessui/react';
import { Flipper, Flipped } from 'react-flip-toolkit';
import cn from 'classnames';

const Tabs = ({ tabs, bg, color, setIndex, theme }) => {
  const [selectedIndex, setSelectedIndex] = useState(setIndex);

  return (
    <div>
      <Tab.Group defaultIndex={selectedIndex} onChange={setSelectedIndex}>
        {tabs.length > 1 && (
          <Tab.List className={cn('overflow-x-auto rounded-full max-w-max', tabTheme[theme])}>
            <Flipper flipKey={selectedIndex} className="flex items-center">
              {tabs.map((tab, idx) => (
                <Tab
                  className={({ selected }) =>
                    selected
                      ? 'text-white transition-colors duration-200 ease-linear relative  py-3 px-4 outline-none'
                      : 'text-neutral-400 transition-colors duration-200 ease-linear relative  py-3 px-4 outline-none'
                  }
                >
                  {selectedIndex === idx && (
                    <Flipped flipId="tab-caret" stagger="none">
                      <div className={cn('absolute inset-0 tab-caret rounded-full', bg)} />
                    </Flipped>
                  )}
                  <span
                    className={cn('relative z-10 whitespace-nowrap', {
                      [color]: selectedIndex === idx
                    })}
                  >
                    {tab.title}
                  </span>
                </Tab>
              ))}
            </Flipper>
          </Tab.List>
        )}
        <Tab.Panels className="mt-16">
          {tabs.map((tab, idx) => (
            <Tab.Panel className="outline-none" key={idx}>
              <div>{tab.content}</div>
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

const tabTheme = {
  dark: 'bg-neutral-800',
  light: 'bg-white'
};

Tabs.defaultProps = {
  setIndex: 0,
  bg: 'bg-scale-mauve',
  color: 'text-white',
  theme: 'dark',
  tabs: [
    {
      title: 'Title 1',
      content: 'Content 1'
    },
    {
      title: 'Title 2',
      content: 'Content 2'
    },
    {
      title: 'Title 3',
      content: 'Content 3'
    }
  ]
};

export default Tabs;
